angular.module('gym.waivers').factory('WaiverBulkInvites', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('waivers').all('bulk_invites');
}]);
